import { createSignal } from "solid-js";

type FocusedTodoInputType = "title" | "subtask" | "row" | null;

const [lastFocusedTodoInput, setLastFocusedTodoInput] = createSignal<FocusedTodoInputType>(null);

export function useTodoFocus() {
  return {
    lastFocusedTodoInput,
    setLastFocusedTodoInput,
  };
}
